import DashboardLayout from "../../../../layoutcontainers/DashboardLayout";
import { Box, Card, CardHeader, IconButton, Stack } from "@mui/material";
import MaterialTypography from "../../../../components/MaterialTypography";
import { useNavigate } from "react-router-dom";
import { postData } from "../../../../api/Services";
import { ArrowBack } from "@mui/icons-material";
import { MotorModelForm } from "../components/motorModelForm";
import { useLoading } from "../../../../components/Loading";
import { useSnackbar } from "../../../../context/popup";

const AddMotorModel = () => {

  const navigate = useNavigate();
  const { setCircleLoading } = useLoading();
  const { showSnackbar } = useSnackbar();

  const handleAddModel = async (modelData) => {
    const payload = {
      name: modelData?.name,
      motorCategoryId: modelData?.vehicleCategory?.value,
      motorMakeId: modelData?.motorMake?.value,
      isActive: modelData?.isActive,
    };
    setCircleLoading(true);
    try {
        const response = await postData(
          "/reference/motor/mmv/model",
          payload
        );
        const successResponse = response?.success;
        const responseMessage = response?.message;
        if (successResponse) {
          navigate("/motor-master/motor-MMV?tabState=model");
          showSnackbar(responseMessage,"success")
        } else {
          showSnackbar(responseMessage,"error");
        }
      } catch (error) {
        console.error("Error Submitting",error);
        showSnackbar(error?.response?.data?.message,"error");
      }
      finally{
        setCircleLoading(false);
      }
  };

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="row" alignItems="center" spacing={1}>
                <IconButton onClick={() => window.history.back()}>
                  <ArrowBack />
                </IconButton>
                <Stack direction="column" spacing={0}>
                  <MaterialTypography variant="h5" fontWeight="medium">
                    Add Model details
                  </MaterialTypography>
                  <MaterialTypography variant="caption" color="text">
                    Add Model Details according to the respective Motor Make here.
                  </MaterialTypography>
                </Stack>
              </Stack>
            </Stack>
          }
        />
        <Box>
          <MotorModelForm onsubmit={handleAddModel} />
        </Box>
      </Card>
    </DashboardLayout>
  );
};

export default AddMotorModel;
